/* eslint-disable global-require */
import { LOCALES } from '../constants';

export default {
    locale: LOCALES.GERMAN,
    messages: require('./messages/de.json'),
    addLocaleData() {
        if (!Intl.RelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/de');
        }
        if (!Intl.PluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/de');
        }
    },
};
